import { FC, useState, ReactNode } from 'react';
import track from 'react-tracking';
import { Button } from '@simplywallst/ui-core';
import Truncator from '@components/Truncator';
import { ViewMode } from '@/components/Company/enum';

export interface ListTruncatorProps {
  children: ReactNode;
  minHeight?: number;
  viewMode?: ViewMode;
}

const ListTruncator: FC<ListTruncatorProps & Tracking> = ({
  children,
  minHeight,
  tracking: { trackEvent },
  viewMode,
}) => {
  const [open, setOpen] = useState(viewMode === ViewMode.Print);
  const [tracked, setTracked] = useState(false);
  return (
    <>
      <Truncator open={open} minHeight={minHeight || 100}>
        {children}
      </Truncator>
      <Button
        styleType="gentleLarge"
        display="block"
        onClick={() => {
          setOpen(!open);
          trackEvent(
            !tracked
              ? {
                  action: 'click',
                  modifier: 'show_more',
                }
              : false
          );
          setTracked(true);
        }}
      >{`Show ${open ? 'less' : 'more'}`}</Button>
    </>
  );
};

export default track({
  type: 'track',
})(ListTruncator);
